import { Box, Menu, MenuItem, MenuProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export type DropDownMenuItem = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
};

type DropDownMenuProps = {
  menuItems: DropDownMenuItem[];
} & Omit<MenuProps, "open">;

const DropDownMenu = ({
  anchorEl,
  onClose,
  menuItems,
  ...props
}: DropDownMenuProps) => {
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          marginTop: 8,
          borderRadius: 8,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
      {...props}
      onClose={onClose}
      open={open}
    >
      {menuItems.map((item) => (
        <MenuItem
          disabled={item?.disabled}
          key={item?.label}
          onClick={() => {
            item.onClick();
            onClose?.({}, "backdropClick");
          }}
        >
          <Box display="flex" alignItems="center" gap={item.icon ? 1 : 0}>
            {item.icon && item?.icon}
            <Typography fontSize="16px">{t(item?.label)}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default DropDownMenu;
